import { render, staticRenderFns } from "./ImageOverlay.vue?vue&type=template&id=87a11720&scoped=true"
import script from "./ImageOverlay.vue?vue&type=script&lang=js"
export * from "./ImageOverlay.vue?vue&type=script&lang=js"
import style0 from "./ImageOverlay.vue?vue&type=style&index=0&id=87a11720&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a11720",
  null
  
)

export default component.exports